import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("opportunityReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	opportunities: null,
	picklists: null,
	lastUpdated: null
});

function opportunityReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset opportunity state");
			return initialState;
		}
		case actionTypes.OPPORTUNITY_LOADED: {
			const loadedOpportunity = action.data;
			let {opportunities} = state;
			const index = (opportunities || []).findIndex(op => op.Id === loadedOpportunity.Id);

			if(index > -1) {
				opportunities[index] = loadedOpportunity;
			}
			else {
				opportunities = [loadedOpportunity];
			}

			return {
				...state,
				opportunities
			};
		}
		case actionTypes.OPPORTUNITIES_LOADED: {
			return {
				...state,
				opportunities: action.data,
				lastUpdated: action.lastUpdated
			};
		}
		case actionTypes.OPPORTUNITY_PICKLISTS_LOADED: {
			return {
				...state,
				picklists: action.data
			};
		}
		default:
			return state;
	}
}

export default opportunityReducer;
